<template>
    <div class="people-block">
        <div class="container">
            <div class="row">
                <div class="col-8 offset-2">
                    <h2>{{ $t('home.our_people') }}</h2>
                    <span>
                        {{ $t('home.our_people_expl') }}
                    </span>
                    <div class="over-ons-button">
                        <router-link to="/labels" class="btn">{{ $t('menu.about') }}</router-link>
                    </div>
                </div>
            </div>
            
            <div class="row justify-content-center d-none d-lg-flex">
                <div class="col-lg-4 col-12 offset-0 person-tile" v-for="owner in owners" :key="owner.id">
                    <router-link :to="'/over-ons/' + owner.content.slug">
                        <div class="share-icon"><i class="fab fa-linkedin"></i></div>
                        <img class="rounded" :src="owner.content.image[0].url" alt="owner foto" />
                        <div class="person-title">
                            <h5>{{ owner.content.name[$i18n.locale] }}</h5>
                            {{ owner.content.function[$i18n.locale] }}
                        </div>
                    </router-link>


                    <a :href="owner.content.url" target="_blank" class="share-icon">
                        <i class="fab fa-linkedin"></i>
                    </a>
                </div>
            </div>

        <div class="d-lg-none">
            <carousel :autoplay="2000" :items-to-show="0.9" :wrap-around="true">
                    <slide v-for="owner in owners" :key="owner.id">
                        <div class="row justify-content-center">
                            <div class="col-lg-4 col-12 offset-0 person-tile">
                                <router-link :to="'/over-ons/' + owner.content.slug">
                                    <div class="share-icon"><i class="fab fa-linkedin"></i></div>
                                    <img class="rounded" :src="owner.content.image[0].url" alt="owner foto" />
                                    <div class="person-title">
                                        <h5>{{ owner.content.name[$i18n.locale] }}</h5>
                                        {{ owner.content.function[$i18n.locale] }}
                                    </div>
                                </router-link>
                                <a :href="owner.content.url" target="_blank" class="share-icon">
                                    <i class="fab fa-linkedin"></i>
                                </a>
                            </div>
                        </div>
                    </slide>    
                </carousel>
            </div>
        </div>
    </div>
</template>
<script>
import 'vue3-carousel/dist/carousel.css'
import { Carousel, Slide } from 'vue3-carousel'
export default {
    components: {
        Carousel,
        Slide
    },
    data() {
        return {
            owners: []
        };
    },
    methods: {

        fetchOwners() {
            const baseURI = 'contenttypes/owners/entries?';

            this.$http.get(baseURI)
                .then(response => {
                    this.owners = response.data.data
                }).catch(error => {
                    console.log("this fetching has error", error)
                })
        }
    },
    created() {
        this.fetchOwners();
    },
}
</script>

<style scoped>

.over-ons-button a {
    color: #fff;
    background-color: #9f8053;
    border-radius: 3px;
    font-size: 14px;
    padding: 15px 40px;
}
.people-block {

    width: 100%;
    text-align: center;
    padding-bottom: 50px;
}

.people-block h2 {
    text-align: center;
    padding-top: 100px;
}

.people-block span {
    text-align: center;
    display: block;

}

.people-block .over-ons-button {
    margin: 60px 0px;
}

.people-block .person-tile {
    position: relative;
}

.people-block .person-tile a {
    text-decoration: none;
}

.people-block .person-tile img {
    max-width: 100%;
    height: 533px;
    overflow: hidden;
    object-fit: cover;
}

.people-block .person-tile .share-icon {
    width: 40px;
    height: 40px;
    background-color: #9f8053;
    position: absolute;
    right: 40px;
    top: 20px;
    border-radius: 5px;
}

.people-block .person-tile .share-icon i {
    font-size: 25px;
    padding: 8px;
    color: #fff;
}

.people-block .person-title {
    text-align: left;
    position: relative;
    background-color: #fff;
    color: #525561;
    padding: 20px;
    margin-left: 20px;
    margin-right: 20px;
    border-radius: 5px;
    margin-top: -60px;
    box-shadow: rgba(0, 0, 0, 0.25) 0px 5px 15px;
}

.about-us .people-block .person-title h5 {
    color: #1e154a;
    font-weight: 600;
}





.people-block .over-ons-button {
    margin: 60px 0px;
}

.people-block .person-tile {
    position: relative;
    text-decoration: none;
}

.people-block .person-tile a {
    text-decoration: none;
}

.people-block .person-tile img {
    max-width: 100%;
    height: 533px;
    overflow: hidden;
    object-fit: cover;
}

.people-block .person-tile .share-icon {
    width: 40px;
    height: 40px;
    background-color: #9f8053;
    position: absolute;
    right: 40px;
    top: 20px;
    border-radius: 5px;
}

.people-block .person-tile .share-icon i {
    font-size: 25px;
    padding: 8px;
    color: #fff;
}

.people-block .person-title h5 {
    color: #1e154a;
    font-weight: 600;
}
</style>